import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FiBook, FiUser, FiLock, FiEye, FiEyeOff, FiAlertCircle, FiArrowLeft } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.username || !formData.password) {
      setError('NIM/NIDN dan password harus diisi');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const result = await login(formData.username, formData.password);
      
      if (result.success) {
        navigate('/');
      } else {
        setError(result.message || 'Login gagal. Periksa kembali NIM/NIDN dan password.');
      }
    } catch (err) {
      setError('Terjadi kesalahan. Silakan coba lagi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-layout">
      <div className="login">
        {/* Left - Branding */}
        <div className="login__branding">
          <div className="login__branding-content">
            <div className="login__logo">
              <img 
                src="/logo.png" 
                alt="STIKES Baramuli Logo" 
                className="login__logo-img"
              />
              <div className="login__logo-text">
                <span className="login__logo-title">STIKES Baramuli</span>
                <span className="login__logo-subtitle">E-Library</span>
              </div>
            </div>
            
            <h1 className="login__branding-title">
              Selamat Datang di<br />
              Perpustakaan Digital STIKES Baramuli
            </h1>
            
            <p className="login__branding-desc">
              Akses ribuan koleksi buku, jurnal, dan referensi akademik 
              kapan saja dan di mana saja.
            </p>

            <div className="login__features">
              <div className="login__feature">
                <span className="login__feature-icon">📚</span>
                <span>1000+ Koleksi Buku</span>
              </div>
              <div className="login__feature">
                <span className="login__feature-icon">📖</span>
                <span>Jurnal Ilmiah</span>
              </div>
              <div className="login__feature">
                <span className="login__feature-icon">🔍</span>
                <span>Pencarian Mudah</span>
              </div>
              <div className="login__feature">
                <span className="login__feature-icon">📱</span>
                <span>Akses Mobile</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right - Form */}
        <div className="login__form-container">
          <div className="login__form-wrapper">
            <div className="login__form-header">
              <img 
                src="/logo.png" 
                alt="STIKES Baramuli Logo" 
                className="login__form-logo"
              />
              <h2>Masuk ke Akun</h2>
              <p>Gunakan NIM (Mahasiswa) atau NIDN (Dosen)</p>
            </div>

            {error && (
              <div className="login__error">
                <FiAlertCircle />
                <span>{error}</span>
              </div>
            )}

            <form className="login__form" onSubmit={handleSubmit}>
              <div className="login__field">
                <label htmlFor="username">NIM / NIDN / NUPTK</label>
                <div className="login__input-wrapper">
                  <FiUser className="login__input-icon" />
                  <input
                    type="text"
                    id="username"
                    name="username"
                    placeholder="Masukkan NIM, NIDN, atau NUPTK"
                    value={formData.username}
                    onChange={handleChange}
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="login__field">
                <label htmlFor="password">Password</label>
                <div className="login__input-wrapper">
                  <FiLock className="login__input-icon" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    name="password"
                    placeholder="Masukkan password"
                    value={formData.password}
                    onChange={handleChange}
                    disabled={loading}
                  />
                  <button
                    type="button"
                    className="login__password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              <div className="login__options">
                <label className="login__remember">
                  <input type="checkbox" />
                  <span>Ingat saya</span>
                </label>
                <a href="#forgot" className="login__forgot">Lupa password?</a>
              </div>

              <button 
                type="submit" 
                className={`login__submit ${loading ? 'login__submit--loading' : ''}`}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="login__spinner"></span>
                    Memproses...
                  </>
                ) : (
                  'Masuk'
                )}
              </button>
            </form>

            <p className="login__footer-text">
              © {new Date().getFullYear()} Sekolah Tinggi Ilmu Kesehatan Baramuli. All rights reserved.
            </p>

            <Link to="/" className="login__back-btn">
              <FiArrowLeft />
              Kembali ke Beranda
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
